/**
 * Звук опасных состояний (п. 10, правило 6 ТЗ). Штатная и аварийная остановка
 * должны различаться на слух — оператор часто смотрит в видео, а не на бейджи.
 */
type Tone = 'warn' | 'alarm' | 'ok';

const TONES: Record<Tone, { freq: number; ms: number; type: OscillatorType; gain: number; repeat: number }> = {
  warn: { freq: 660, ms: 120, type: 'sine', gain: 0.05, repeat: 1 },
  alarm: { freq: 320, ms: 180, type: 'square', gain: 0.07, repeat: 3 },
  ok: { freq: 880, ms: 90, type: 'sine', gain: 0.04, repeat: 1 },
};

export class Beeper {
  private ctx: AudioContext | null = null;
  enabled = true;

  private ensure(): AudioContext | null {
    if (!this.enabled) return null;
    if (!this.ctx) {
      try {
        this.ctx = new AudioContext();
      } catch {
        return null;
      }
    }
    if (this.ctx.state === 'suspended') void this.ctx.resume();
    return this.ctx;
  }

  play(tone: Tone): void {
    const ctx = this.ensure();
    if (!ctx) return;
    const t = TONES[tone];
    for (let i = 0; i < t.repeat; i++) {
      const start = ctx.currentTime + i * (t.ms + 60) / 1000;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = t.type;
      osc.frequency.value = t.freq;
      gain.gain.setValueAtTime(t.gain, start);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + t.ms / 1000);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + t.ms / 1000 + 0.02);
    }
  }
}
